import * as yup from 'yup';

import {
  REQUIRED,
  NUMBER,
  POSITIVE,
  MAXIMUM,
  INTEGER,
} from '../forms/errorsText.js';
import DatePresenter from '../presenters/DatePresenter';

const MAX_CASHBACK_RATE = 100;
const IS_TEMPORARY_RATE = 'isTemporaryRate';

export const validationFields = {
  startDate: yup.string().required(REQUIRED),
  rate: yup
    .number(NUMBER)
    .required(REQUIRED)
    .positive(POSITIVE)
    .max(MAX_CASHBACK_RATE, MAXIMUM)
    .integer(INTEGER),
  rateType: yup.string().required(REQUIRED),
  isTemporaryRate: yup.boolean(),
  endDate: yup.string().when(IS_TEMPORARY_RATE, {
    is: true,
    then: yup.string().required(REQUIRED),
  }),
  nextRate: yup.number(NUMBER).when(IS_TEMPORARY_RATE, {
    is: true,
    then: yup
      .number(NUMBER)
      .required(REQUIRED)
      .positive(POSITIVE)
      .max(MAX_CASHBACK_RATE, MAXIMUM)
      .integer(INTEGER),
  }),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = () => {
  return {
    startDate: DatePresenter.today(),
    endDate: DatePresenter.daysAhead(2),
    rate: '',
    nextRate: '',
    rateType: '',
    isTemporaryRate: false,
  };
};
